module.exports = "<div class=\"animated fadeIn\">\n<div class=\"card errorbox blankpage\">\n        <img src=\"assets/img/error-img.png\" class=\"erroeimg\" alt=\"\">\n        <h6 class=\"errormsgs\">Page Not Found</h6>\n        <p class=\"error-p\">Sorry, but the page you were trying to view does not exist.</p>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/src/app/error.component.html
// module id = ../../../../../src/app/error.component.html
// module chunks = main